module.exports = __webpack_public_path__ + "img/sld_scb_23_t1_b1_green.62b4a09e.svg";